import React, { useEffect, useState } from 'react'
import {
  KanbanIcon,
  RowsIcon,
  RocketLaunchIcon,
} from '@phosphor-icons/react'
import { backendUrl } from '../../utils/env'

const ReleasePlans: React.FC = () => {
  const [boards, setBoards] = useState([])
  const [selectedBoard, setSelectedBoard] = useState('')
  const onSubmit = async () => {
    if (!selectedBoard) return
    const response = await fetch(
      `${backendUrl}/engagement/releaseplan/${selectedBoard}`,
    )
    const arrayBuffer = await response.arrayBuffer()
    const blob = new Blob([arrayBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)
    const downButton = document.createElement('a')
    downButton.setAttribute('href', url)
    downButton.setAttribute('download', `${selectedBoard}.xlsx`)
    document.body.appendChild(downButton)
    downButton.click()
    document.body.removeChild(downButton)
    window.URL.revokeObjectURL(url)
  }

  useEffect(() => {
    const fetchBoards = async () => {
      const response = await fetch(`${backendUrl}/engagement/boards`)
      const boards = await response.json()
      setBoards(boards)
    }

    fetchBoards()
  }, [])

  const onSelectBoard = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedBoard(e.target.value)
  }
  return (
    <div className="release-plans">
      <h1 className="release-plans__title">Release Plan</h1>
      <div className="release-plans__card">
        <div className="release-plans__icon">
          <KanbanIcon
            size={48}
            weight="regular"
            color="#1F0E38"
            style={{ opacity: 0.2 }}
          />
        </div>
        <h2 className="release-plans__heading">Generate a Release Plan</h2>
        <p className="release-plans__description">
          Select a board to generate a release plan from your project management
          tool.
        </p>
        <div className="release-plans__actions">
          <div className="release-plans__select-wrapper">
            <RowsIcon
              size={16}
              weight="regular"
              color="#0A0A0A"
              className="release-plans__select-icon"
            />
            <span className="release-plans__select-label">
              {selectedBoard || 'Select Board'}
            </span>
            <select
              className="release-plans__select"
              value={selectedBoard}
              onChange={onSelectBoard}
            >
              <option value="">Select Board</option>
              {boards.length &&
                boards.map((board: { id: string; name: string }) => (
                  <option key={board.id} value={board.name}>
                    {board.name}
                  </option>
                ))}
            </select>
          </div>
          <button
            type="button"
            className="release-plans__generate-btn"
            disabled={!selectedBoard}
            onClick={onSubmit}
          >
            <RocketLaunchIcon size={16} weight="regular" color="#ffffff" />
            Generate Release Plan
          </button>
        </div>
      </div>
    </div>
  )
}

export default ReleasePlans
